
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../reducers/formConfig2.reducers';

export const selectDataState = createFeatureSelector<State>('formConfig2Data');

export const selectFormConfig2Data = createSelector(selectDataState, (state) => state.formConfig2Data);
export const selectFormConfig2Loading = createSelector(selectDataState, (state) => state.loading);
export const selectFormConfig2Error = createSelector(selectDataState, (state) => state.error);
